export default "__VITE_ASSET__BCg2EAQN__"